export const TAB = {
  TRACKS: 0,
  PLAYLISTS: 1,
  LINKS: 2,
};
